import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLayout, { LegalSection } from '../components/LegalPageLayout';

/**
 * Phase 40 · Privacy Policy — versione ufficiale Nymia/Bull Marketing S.r.l.s.
 * Contenuto redatto conformemente al Regolamento (UE) 2016/679 (GDPR),
 * al D.Lgs. 196/2003 (Codice Privacy) come modificato dal D.Lgs. 101/2018,
 * alla ePrivacy Directive, al Digital Services Act (Reg. UE 2022/2065),
 * e ai provvedimenti generali del Garante per la protezione dei dati personali.
 */
const SECTION_IDS = [
  'introduction',
  'controller',
  'definitions',
  'data_collected',
  'data_provided_by_user',
  'data_collected_automatically',
  'payment_data',
  'creator_data',
  'purposes',
  'legal_basis',
  'retention',
  'sharing',
  'international_transfers',
  'security',
  'automated_decisions',
  'cookies_link',
  'meta_pixel',
  'google_analytics',
  'stripe_payments',
  'livekit',
  'wasabi',
  'user_rights',
  'right_to_complain',
  'minors',
  'changes',
  'contact',
];

// Data di ultima revisione ufficiale del documento.
const LAST_UPDATED = '2026-02-11';

const PrivacyPage = () => {
  const { t } = useTranslation('legal');
  const sections = SECTION_IDS.map((id) => ({
    id,
    title: t(`privacy.sections.${id}`),
  }));

  return (
    <LegalPageLayout
      namespace="legal"
      eyebrow="Nymia · Privacy Policy"
      title={t('privacy.title')}
      subtitle={t('privacy.subtitle')}
      lastUpdated={LAST_UPDATED}
      sections={sections}
      testId="privacy-page"
    >
      {SECTION_IDS.map((id) => (
        <LegalSection
          key={id}
          id={id}
          title={t(`privacy.sections.${id}`)}
          body={t(`privacy.body.${id}`, { defaultValue: '' })}
          testId={`privacy-section-${id}`}
        />
      ))}
    </LegalPageLayout>
  );
};

export default PrivacyPage;
